// config.js
//export const SERVER_NAME = 'https://e3d.ai/apitest';  // Remote API endpoint
export const SERVER_NAME = 'https://e3d.ai/api';
//export const SERVER_NAME = 'http://localhost:3002';
export const PCAP = 0;
export const ETHERSCAN = 1;
export const BSCSCAN = 2;
export const genericTokenIcon = `${process.env.PUBLIC_URL}/eth_icon.png`;
export const genericUserIcon = `${process.env.PUBLIC_URL}/smile_icon.png`;
export const futLogoIcon200 = `${process.env.PUBLIC_URL}/fut_logo_200.png`;
export const metamaskLogo = `${process.env.PUBLIC_URL}/metamask.svg`;
export const uniswapLogo = `${process.env.PUBLIC_URL}/uniswap.png`;
export const etherscanLogo = `${process.env.PUBLIC_URL}/etherscan-logo-circle-light.png`;
export const genericNodeIcon = `${process.env.PUBLIC_URL}/blue-dot-icon-22.png`;
export const globeImage = `${process.env.PUBLIC_URL}/e3d_tokens_nolabels.png`; 

// Smart contract addresses
export const E3D_TOKEN_ADDRESS = '0x6488861b401F427D13B6619C77C297366bCf6386';  // E3D Token address
export const E3D_NFT_MANAGER_ADDRESS = '0xeED4620ff525101Ffcf7327378232CA9EF778D47';  // E3D NFT Manager address

// Smart contract ABIs
export const E3D_TOKEN_ABI = [
  // ERC20 Token Standard Interface
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address account) view returns (uint256)',
  'function transfer(address recipient, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function transferFrom(address sender, address recipient, uint256 amount) returns (bool)',
  'event Transfer(address indexed from, address indexed to, uint256 value)',
  'event Approval(address indexed owner, address indexed spender, uint256 value)'
];

export const E3D_NFT_MANAGER_ABI = [
  // NFT Manager Functions
  'function stakedE3D(address staker) view returns (uint256)',
  'function rewardRateStaking() view returns (uint256)',
  'function stake(uint256 amount) external',
  'function withdrawStake(uint256 amount) external',
  'event E3DStaked(address indexed staker, uint256 amount)',
  'event E3DWithdrawn(address indexed staker, uint256 amount)'
];

